export default "__VITE_ASSET__BiHnIRUQ__"